import gql from "graphql-tag";

export const GET_NEWS_LIST = gql`
    query NewsList($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        newsList(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            newsId
            newsType
            newsDetail
            createdAt
            updatedAt
            deleted
            deletedAt
        }
    }
`;

export const CREATE_NEWS = gql`
    mutation CreateNews($newNews: newNews!) {
        createNews(
            newNews: $newNews
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_NEWS = gql`
    mutation UpdateNews($changedNews: changedNews!) {
        updateNews(
            changedNews: $changedNews
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_NEWS = gql`
    mutation DeleteNews($deleteNewsId: ID!) {
        deleteNews(
            deleteNewsId: $deleteNewsId
        ) {
            returnCode
            message
        }
    }
`;
